import { Box, FormControl, Typography } from '@hermes/web-components'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { useBookSearch } from '@hermes/search'
import { SortSearchSelector } from './SearchSortSelector'

export const SearchSortSubHeader = () => {
  const { query } = useBookSearch()
  const { t } = useTranslateMessage()
  return (
    <Box
      width={'100%'}
      maxWidth={'100%'}
      display="flex"
      justifyContent={'space-between'}
      flexDirection={'row'}
      flexWrap={'nowrap'}
      marginBottom={'20px'}
      gap={'8px'}
    >
      <Typography maxWidth={'50%'} variant={'caption'} sx={{ wordWrap: 'break-word' }}>
        {query.trim() &&
          `${t({
            id: 'search.query',
            defaultMessage: 'Showing results for'
          })} '${query}'`}
      </Typography>
      <FormControl>
        <SortSearchSelector />
      </FormControl>
    </Box>
  )
}
